


































































































































































































































































import { JobAlertV2 } from '../../models/JobAlert/JobAlertV2';
import { vxm } from '../../store.vuex';

export default {
  props: {
    header: {
      default: '',
      type: String,
    },
    body: {
      default: '',
      type: String,
    },
    notificationSMS: {
      default: false,
      type: Boolean,
    },
    notificationEmail: {
      default: false,
      type: Boolean,
    },
    notificationPush: {
      default: false,
      type: Boolean,
    },
    notificationWhatsapp: {
      default: false,
      type: Boolean,
    },

    okText: {
      default: 'Ok',
      type: String,
    },
       filterList: {
        default: [],
        type: Array,
      },
    jobAlertStatus: {
      default: false,
      type: Boolean,
    },
    isTestDevice:{
      default:false,
      type:Boolean
    },
    jobresponse: {
      type: JobAlertV2,
      default: new JobAlertV2(),
    },
    onToggle: {
      type: Function,
      default: () => {},
    },
    cancelText: {
      default: 'Cancel',
      type: String,
    },
    onOk: {
      default: () => {},
      type: Function,
    },
    onDelete: {
      default: () => {},
      type: Function,
    },
    onCancel: {
      default: () => {},
      type: Function,
    },
    handleStylingChanges: {
      default: () => {},
      type: Function,
    },
      handlClassNames: {
      default: () => {},
      type: Function,
    },
    okBtnClass: {
      default: '',
      type: String,
    },
    isMobileDevice:{
       default: false,
      type: Boolean,
    }
  },

mounted(){          
  }
}

